import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "../utils/axiosInstance";
import FilterSidebar from "../components/filter/FilterSidebar";
import ProductList from "../components/product/ProductList";
import Toolbar from "../containers/Header/Toolbar/Toolbar";
import Footer from "../containers/Footer/Footer";
import useDynamicTabTitle from "../useDynamicTabTitle";

const SearchResultsPage = () => {
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [brands, setBrands] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  // گرفتن مقدار جستجو و دسته انتخابی از query string
  const query = searchParams.get("q") || "";
  const category = searchParams.get("category") || "";
useDynamicTabTitle(`Search Results For:${query}`);
  // گرفتن داده‌ها از سرور
  const fetchProducts = async (extraFilters = {}) => {
    try {
      setLoading(true);
      const params = {
        search: query,
        category,
        ...extraFilters,
      };
      const res = await axios.get(
        `/products`,
        { params }
      );
      setProducts(res.data.products || []);
      setTotalCount(res.data.totalCount || 0);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  // گرفتن برندها فقط یک بار
  const fetchBrands = async () => {
    try {
      const res = await axios.get("/brands");
      setBrands(res.data.data);
      console.log("brand" ,res.data.data)
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };

  // وقتی متن جستجو یا دسته تغییر کرد
  useEffect(() => {
    fetchProducts();
    fetchBrands();
  }, [query, category]);

  // وقتی کاربر فیلتر اعمال می‌کند
  const handleApplyFilters = (
    categoryId,
    selectedBrands,
    minPrice,
    maxPrice,
    selectedAttributes
  ) => {
    const newFilters = {
      category: categoryId || category,
      brand: selectedBrands,
      minPrice,
      maxPrice,
      attributes: selectedAttributes,
    };
    setFilters(newFilters);
    fetchProducts(newFilters);
  };

  return (
    <>
     <Toolbar/>
    <div className="container-fluid mt-4">
     
      <div className="row">
        {/* سایدبار فیلتر */}
        <div className="col-12 col-lg-3 order-lg-0 ">
          <FilterSidebar
            brands={brands}
            applyFilters={handleApplyFilters}
            categoryId={category}
          />
        </div>

        {/* لیست محصولات */}
        <div className="col-12 order-lg-1 col-lg-9 pe-4">
          
          <h5 className="fw-bold mb-3">
            Search Results For: <span className="text-primary">"{query}"</span>
            {category && <span> (Category: {category})</span>}
          </h5>

          {loading ? (
            <div className="text-center py-5">Loading ...</div>
          ) : products.length > 0 ? (
            <ProductList products={products} />
          ) : (
            <div className="text-center py-5 text-muted">
              No Products Found.
            </div>
          )}
        </div>
      </div>
    </div>
    <Footer/>
</>  );
};

export default SearchResultsPage;
